import React, { useEffect, useRef, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const AUTO_PLAY_MS = 5000;

const FeatureCarousel = ({ slides = [] }) => {
  const [index, setIndex] = useState(0);
  const timerRef = useRef(null);
  const count = slides.length;

  const go = (delta) => setIndex((prev) => (prev + delta + count) % count);
  const goTo = (i) => setIndex(((i % count) + count) % count);

  useEffect(() => {
    if (count <= 1) return;
    timerRef.current = setInterval(() => go(1), AUTO_PLAY_MS);
    return () => clearInterval(timerRef.current);
  }, [count]);

  const pause = () => timerRef.current && clearInterval(timerRef.current);
  const resume = () => {
    if (count <= 1) return;
    pause();
    timerRef.current = setInterval(() => go(1), AUTO_PLAY_MS);
  };

  if (count === 0) return null;

  return (
    <div className="carousel" onMouseEnter={pause} onMouseLeave={resume}>
      <div className="carousel-viewport">
        <AnimatePresence initial={false} mode="wait">
          <motion.div
            key={index}
            className="carousel-slide"
            initial={{ opacity: 0, x: 40 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -40 }}
            transition={{ duration: 0.4 }}
            style={{ backgroundImage: `url(${slides[index].image})` }}
          >
            <div className="carousel-overlay" />
            <div className="carousel-content">
              <h3>{slides[index].title}</h3>
              <p>{slides[index].description}</p>
            </div>
          </motion.div>
        </AnimatePresence>
      </div>

      {/* Controls */}
      <button className="carousel-arrow left" aria-label="Previous" onClick={() => go(-1)}>
        ‹
      </button>
      <button className="carousel-arrow right" aria-label="Next" onClick={() => go(1)}>
        ›
      </button>

      {/* Dots */}
      <div className="carousel-dots">
        {slides.map((_, i) => (
          <button
            key={i}
            className={`dot ${i === index ? 'active' : ''}`}
            aria-label={`Go to slide ${i + 1}`}
            onClick={() => goTo(i)}
          />)
        )}
      </div>
    </div>
  );
};

export default FeatureCarousel;
